import Vue from "vue"

import router from "@/router"
import store from "@/store"

import App from "./App.vue"
import config from "./app.config"

// Import plugins
import i18n from "@/plugins/i18n"
import vuetify from "@/plugins/vuetify"
import generics from "@/plugins/generics"
import "@/plugins/apexchart"
import "@/plugins/gtag"

// Import global sass
import "@/assets/scss/variables.scss"
import CKEditor from "@ckeditor/ckeditor5-vue2"

// Setup application configuration
Vue.prototype.$appConfig = config.general
Vue.config.productionTip = false
Vue.use(CKEditor)

new Vue({
  router,
  store,
  vuetify,
  i18n,
  generics,
  render: h => h(App)
}).$mount("#app")
